// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.flex_X8_5_ {
  display : flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items : center;
}
.flex_X8_5_ > * {
  margin : 8px;
}

.flex_X8_5_ > *:first-child {

}

.flex_X8_5_ > *:last-child {

}

.flex_X8_5_.flex-noSpace__VA85 > * {
  margin : 0px;
}

.flex_X8_5_.flex-noSpace__VA85 > *:first-child {
  /*background: black;
  flex : 1 1 auto;*/
}

.flex_X8_5_ > *:last-child {

}


.flex_X8_5_.flex-hSpace_tDViV > * {
  margin : 0 8px 0 0;
}

.flex_X8_5_.flex-hSpace_tDViV > *:last-child {
  margin-right: 0
}


.flex_X8_5_.flex-vSpace_MbX1Y {
  padding-top: 4px;
  padding-bottom:4px;
  /*flex-direction:column;*/
}
.flex_X8_5_.flex-vSpace_MbX1Y > * {
  margin : 4px 0 4px 0;
}
/*
.flex.flex-vSpace > *:last-child {
  margin-bottom: 8px
}*/`, "",{"version":3,"sources":["webpack://./src/views/Flex.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;mBACiB;AACnB;;AAEA;;AAEA;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE;AACF;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;AACA;;;EAGE","sourcesContent":["\n.flex {\n  display : flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items : center;\n}\n.flex > * {\n  margin : 8px;\n}\n\n.flex > *:first-child {\n\n}\n\n.flex > *:last-child {\n\n}\n\n.flex.flex-noSpace > * {\n  margin : 0px;\n}\n\n.flex.flex-noSpace > *:first-child {\n  /*background: black;\n  flex : 1 1 auto;*/\n}\n\n.flex > *:last-child {\n\n}\n\n\n.flex.flex-hSpace > * {\n  margin : 0 8px 0 0;\n}\n\n.flex.flex-hSpace > *:last-child {\n  margin-right: 0\n}\n\n\n.flex.flex-vSpace {\n  padding-top: 4px;\n  padding-bottom:4px;\n  /*flex-direction:column;*/\n}\n.flex.flex-vSpace > * {\n  margin : 4px 0 4px 0;\n}\n/*\n.flex.flex-vSpace > *:last-child {\n  margin-bottom: 8px\n}*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flex": `flex_X8_5_`,
	"flex-noSpace": `flex-noSpace__VA85`,
	"flex-hSpace": `flex-hSpace_tDViV`,
	"flex-vSpace": `flex-vSpace_MbX1Y`
};
export default ___CSS_LOADER_EXPORT___;
